import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { logoutUser } from "../redux/actions/LoginActions";
import { LoadingOutlined } from "@ant-design/icons";
import useAutoLogout from "./useAutoLogout";

const PrivateRoutes = ({ element }) => {
  const { user, isInitialized } = useSelector((state) => state.auth || {});
  const dispatch = useDispatch();
  const [checkingAuth, setCheckingAuth] = useState(true);
  const navigate = useNavigate();

  useAutoLogout();

  const customSpinIndicator = (
    <LoadingOutlined style={{ fontSize: 70, color: "#43CE0C" }} spin />
  );

  useEffect(() => {
    const checkAuthentication = () => {
      const token = localStorage.getItem("token");
      const storedUser = localStorage.getItem("user");

      // ✅ Vérification simplifiée : on fait confiance à l'intercepteur API pour le refresh
      if (!token || !storedUser) {
        dispatch(logoutUser());
        navigate("/");
      }

      setCheckingAuth(false);
    };

    checkAuthentication();
  }, [dispatch, navigate]);

  // ✅ Loading state pendant la vérification initiale
  if (!isInitialized || checkingAuth) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "#f0f2f5",
        }}
      >
        {customSpinIndicator}
      </div>
    );
  }

  // ✅ Vérification finale simple
  const token = localStorage.getItem("token");
  if (!user || !token) {
    navigate("/");
    return null;
  }

  return element;
};

export default PrivateRoutes;
